var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChinese(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 30,
    viewBox: "0 0 48 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H48V36.5738H0V0Z",
    fill: "#D60A2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.999 6.672L9.6813 10.3981L13.4428 10.9955L10.7207 13.8957L11.3636 17.9912L7.999 16.0575L4.63392 17.9912L5.27684 13.8957L2.55469 10.9955L6.31623 10.3981L7.999 6.672Z",
    fill: "#FED953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9643 13.8235L18.6368 15.3122L20.14 15.5509L19.0521 16.7102L19.3088 18.3462L17.9643 17.5738L16.6198 18.3462L16.8764 16.7102L15.7891 15.5509L17.2923 15.3122L17.9643 13.8235Z",
    fill: "#FED953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1678 7.31372L18.3964 8.29041L19.8286 7.73799L19.3583 9.31704L20.2818 10.6353L18.7629 10.6343L17.9007 12.0014L17.4323 10.4219L15.9766 9.94866L17.2056 8.97348L17.1678 7.31372Z",
    fill: "#FED953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1979 2.82113L14.9108 4.45163L15.977 5.63465L14.4696 5.83998L13.7699 7.31359L13.1256 5.81021L11.627 5.53779L12.736 4.4032L12.5094 2.7616L13.8396 3.56373L15.1979 2.82113Z",
    fill: "#FED953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1979 19.5263L14.9108 21.1568L15.977 22.3393L14.4696 22.5447L13.7699 24.0183L13.1256 22.5149L11.627 22.243L12.736 21.1084L12.5094 19.4668L13.8396 20.2689L15.1979 19.5263Z",
    fill: "#FED953"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 31.48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChinese);
export default __webpack_public_path__ + "static/media/Chinese.4826571dea3abe3176dca5381051c5c0.svg";
export { ForwardRef as ReactComponent };